import { redirect } from 'react-router-dom';
import type { LoaderFunctionArgs } from 'react-router-dom';
import { apiGet } from '../lib/apiClient.js';
import type { TenantState } from '../app/TenantContext.js';

interface Membership {
  tenantId: string;
  tenantName: string;
  status: string;
}

export async function tenantLoader({ params, request }: LoaderFunctionArgs): Promise<TenantState> {
  const slug = params.tenantSlug;
  if (!slug) throw redirect('/404');

  try {
    const response = await apiGet<{ memberships: Membership[] }>('/api/v1/users/me/memberships', { signal: request.signal });
    const normalized = slug.toLowerCase();
    const membership = response.data.memberships.find((item) =>
      item.status === 'ACTIVE' && (
        item.tenantId.toLowerCase() === normalized ||
        item.tenantName.toLowerCase().replace(/[^a-z0-9]+/g, '-') === normalized
      ),
    );

    if (!membership) throw redirect('/access-denied');

    return {
      id: membership.tenantId,
      slug,
      name: membership.tenantName,
      status: membership.status,
    };
  } catch (error) {
    if (error instanceof Response) throw error;
    throw redirect('/signin');
  }
}
